import { ForgotPass } from '@you-go-vn/components';
import ForgotPassMerchantStep2 from '@you-go-vn/components/src/Login/ForgotPassMerchantStep2';
import { message } from 'antd';
import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { authService } from '../auth/services';
import ResetPasswordPage from './reset-password';
const ForgotPassPage = () => {

  const [searchParams, setSearchParams] = useSearchParams();

  const [email, setEmail] = useState("");
  const [isStep2, setIsStep2] = useState(false);
  const [isStep3, setIsStep3] = useState(false);


  if (isStep3) {
    return (
     <ResetPasswordPage />
    );
  }

  if (isStep2) {
    return (
      <ForgotPassMerchantStep2
      email={email}
      onFinish={async (value) => {
        const hideMessage = message.loading(
          'Đang kiểm tra mã xác nhận',
          0,
        );
        try {
          const res = await authService.checkPassCode({email, code: value.code});
          console.log(res.data);
          if (res.data.message === 'success') {
            console.log(res.data.data.token);
            message.success('Thành công');
            searchParams.set('token', res.data.data.token);
            searchParams.set('email', email);
            setSearchParams(searchParams);
            setIsStep3(true);
            return {};
          }

          return {};
        } catch (error: any) {
          message.error('Đã xảy ra lỗi, vui lòng kiểm tra lại!');

          if (error.response) {
            return { errors: error.response.data.errors };
          }
          return {};
        }finally {
          hideMessage();
        }
      }
      }
      />
    );
  }



  return (
    <ForgotPass
      onFinish={async (values) => {
        const hideMessage = message.loading(
          'Đang gửi yêu cầu khôi phục mật khẩu qua Email',
          0,
        );
        try {
          const res = await authService.requestPasswordRecovery(values);
          if (res.data.message === 'success') {
            setEmail(values.email);
            message.success('Thành công');
            setIsStep2(true);
            return {};
          }
          if (res.data.errors) {
            message.error('Đã xảy ra lỗi, vui lòng kiểm tra lại!');
            return { errors: res.data.errors };
          }
          return {};
        } catch (error: any) {
          message.error('Đã xảy ra lỗi, vui lòng kiểm tra lại!');

          // if has field error
          if (error.response) {
            return { errors: error.response.data.errors };
          }
          return {};
        } finally {
          hideMessage();
        }
      }}
    />
  );
};

export default ForgotPassPage;
